module.exports = __webpack_public_path__ + "static/media/sensor-alert.8b5e31e0.svg";